<h3 class="text-center">{{ conference.name }}</h3>
<h5 class="text-center">{{ conference.startDate | date: 'shortDate' }} - {{ conference.endDate | date: 'shortDate' }}</h5>
